import { render, staticRenderFns } from "./ShowsForm.vue?vue&type=template&id=e4b58502&"
import script from "./ShowsForm.vue?vue&type=script&lang=js&"
export * from "./ShowsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports